module.exports = __webpack_public_path__ + "static/media/gt-america-standard-regular-italic.75c310ae.woff2";